import React from 'react';
import { Link } from 'react-router-dom';
import { Button } from '../ui/button';
import {
  LayoutDashboard, Calendar, Package, Star, PoundSterling,
  ShieldCheck, BarChart3, Layers, Video, Tag, ArrowRight
} from 'lucide-react';

const PREVIEW_TABS = [
  { icon: LayoutDashboard, label: 'Overview' },
  { icon: Calendar, label: 'Bookings' },
  { icon: Package, label: 'Services' },
  { icon: Star, label: 'Portfolio' },
  { icon: Layers, label: 'Before & After' },
  { icon: Video, label: 'Videos' },
  { icon: PoundSterling, label: 'Earnings' },
  { icon: Calendar, label: 'Availability' },
  { icon: Tag, label: 'Discounts' },
  { icon: ShieldCheck, label: 'Policies' },
  { icon: Star, label: 'Reviews' },
  { icon: BarChart3, label: 'Analytics' },
];

export function LockedDashboardPreview({ status }) {
  return (
    <div className="relative mt-2" data-testid="locked-dashboard-preview">
      <div className="absolute inset-0 z-10 flex items-start justify-center pt-24 pointer-events-none">
        <div className="pointer-events-auto bg-white/95 backdrop-blur-sm border border-[#E6E4DD] rounded-xl shadow-lg px-8 py-6 text-center max-w-md mx-4" data-testid="locked-overlay-message">
          <div className="w-12 h-12 rounded-full bg-[#F9F6F0] flex items-center justify-center mx-auto mb-3">
            <ShieldCheck className="h-6 w-6 text-[#D4AF37]" />
          </div>
          <h3 className="font-heading text-lg font-medium text-[#1A1A1A] mb-1">
            {status === 'pending' ? 'Almost There!' : 'Unlock Your Dashboard'}
          </h3>
          <p className="text-sm text-stone-500 mb-4">
            {status === 'pending'
              ? 'Your profile is under review. These features will be unlocked once you\'re approved.'
              : 'Complete your profile to unlock all dashboard features, bookings, earnings, analytics and more.'}
          </p>
          {status !== 'pending' && (
            <Link to="/provider/onboarding">
              <Button className="btn-primary" data-testid="locked-continue-setup-btn">
                <ArrowRight className="h-4 w-4 mr-2" />
                Continue Setup
              </Button>
            </Link>
          )}
        </div>
      </div>

      <div className="filter blur-[2px] opacity-50 select-none pointer-events-none" aria-hidden="true">
        <div className="bg-white border border-[#E6E4DD] rounded-lg p-1 mb-8 flex flex-nowrap gap-1 overflow-x-auto scrollbar-hide">
          {PREVIEW_TABS.map((tab) => (
            <div key={tab.label} className="flex items-center gap-2 px-3 py-2 rounded-md text-sm text-stone-400 shrink-0">
              <tab.icon className="h-4 w-4" />
              {tab.label}
            </div>
          ))}
        </div>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-4 mb-6">
          <div className="card-surface p-5"><div className="h-4 bg-stone-200 rounded w-24 mb-2" /><div className="h-8 bg-stone-100 rounded w-16" /></div>
          <div className="card-surface p-5"><div className="h-4 bg-stone-200 rounded w-24 mb-2" /><div className="h-8 bg-stone-100 rounded w-16" /></div>
          <div className="card-surface p-5"><div className="h-4 bg-stone-200 rounded w-24 mb-2" /><div className="h-8 bg-stone-100 rounded w-16" /></div>
        </div>
        <div className="card-surface p-6"><div className="h-4 bg-stone-200 rounded w-32 mb-4" /><div className="space-y-3">{[1,2,3].map(i => <div key={i} className="h-12 bg-stone-100 rounded" />)}</div></div>
      </div>
    </div>
  );
}
